export const pageSEO = {
  // Home
  home: {
    title: "NGO Website Development India",
    description: "Govindani Infotech builds NGO donation platforms, websites, CRM systems and digital growth solutions for nonprofits and businesses across India. 900+ websites engineered, 550 of them for non-profits, ₹1100+ crore processed securely.",
    keywords: "NGO website development, donation platform India, WhatsApp Business API, social media marketing, Google Ads, SEO services, web development Pune",
  },

  // About
  aboutFounder: {
    title: "About Sujeet Govindani | Founder & CEO",
    description: "Meet Sujeet Govindani, founder of Govindani Infotech — from 550 NGO websites to ₹1100+ crore in donations processed. Our journey so far.",
    keywords: "Sujeet Govindani, Govindani Infotech founder, NGO digital transformation, Pune entrepreneur",
  },
  aboutCompany: {
    title: "About Our Digital Solutions in India",
    description: "Govindani Infotech Pvt. Ltd. is a Pune-based digital solutions company specializing in NGO websites, donation platforms, WhatsApp API, and digital marketing since 2018.",
    keywords: "Govindani Infotech, digital solutions company Pune, NGO website developer India",
  },

  // Services
  websiteCreation: {
    title: "Website Development Company in India",
    description: "Govindani Infotech is India's leading website development company offering custom web design, React development, WordPress, and e-commerce solutions. 900+ websites built for NGOs and businesses, 550 of them for non-profits.",
    keywords: "website development company India, custom web design, React development, WordPress development, e-commerce website, web development Pune",
  },
  metaAds: {
    title: "Meta Ads Management India | Facebook Ads",
    description: "Professional Meta Ads management services in India. ROI-focused Facebook and Instagram advertising campaigns for NGOs, e-commerce, and businesses. Get 3-5x ROAS with Govindani Infotech.",
    keywords: "Meta Ads management, Facebook advertising agency, Instagram ads India, social media advertising, Meta Ads company Pune",
  },
  googleAds: {
    title: "Google Ads Management India | PPC",
    description: "Expert Google Ads management services in India. PPC campaigns, search ads, display ads, and YouTube advertising for maximum ROI. Govindani Infotech - your trusted Google Ads partner.",
    keywords: "Google Ads management, PPC advertising agency, Google Ads India, search engine marketing, Google Ads company Pune",
  },
  seo: {
    title: "SEO Services India | Optimization Agency",
    description: "Professional SEO services in India. Technical SEO, on-page optimization, content marketing, and local SEO for higher rankings. Govindani Infotech - best SEO agency in India.",
    keywords: "SEO services India, search engine optimization, SEO agency, technical SEO, local SEO, SEO company Pune",
  },
  socialMedia: {
    title: "Social Media Marketing India | SMM Agency",
    description: "Professional social media marketing services in India. Instagram, Facebook, LinkedIn, and YouTube marketing for NGOs, businesses, and brands. Govindani Infotech - your social media partner.",
    keywords: "social media marketing India, Instagram marketing, Facebook marketing, LinkedIn marketing, social media agency Pune",
  },
  whatsappFlow: {
    title: "WhatsApp Business API India | Chatbot Solutions",
    description: "WhatsApp Business API setup, chatbot development, and automation solutions in India. Boost customer engagement with WhatsApp marketing. Govindani Infotech - official WhatsApp partner.",
    keywords: "WhatsApp Business API, WhatsApp chatbot, WhatsApp automation, WhatsApp marketing India, WhatsApp API setup",
  },
  aiAutomation: {
    title: "AI Automation Solutions India | Chatbots",
    description: "AI-powered automation solutions for businesses in India. Chatbots, workflow automation, and AI tools to boost productivity. Govindani Infotech - your AI transformation partner.",
    keywords: "AI automation India, chatbot development, workflow automation, AI solutions, artificial intelligence company India",
  },
  videography: {
    title: "Professional Videography India | Business Video",
    description: "Professional videography services in India. Corporate videos, event coverage, promotional videos, and drone shoots. Govindani Infotech - creative video production agency.",
    keywords: "videography services India, corporate video production, event videography, promotional video, video production Pune",
  },
  videoEditing: {
    title: "Video Editing Services India | Professional",
    description: "Professional video editing services in India. YouTube editing, social media reels, corporate videos, and animation. Govindani Infotech - creative video editing agency.",
    keywords: "video editing services India, YouTube video editing, social media reels, corporate video editing, video post-production",
  },
  photography: {
    title: "Professional Photography India | Product Photos",
    description: "Professional photography services in India. Product photography, event coverage, corporate headshots, and real estate photography. Govindani Infotech - creative photography agency.",
    keywords: "photography services India, product photography, event photography, corporate photography, real estate photography",
  },
  graphicDesign: {
    title: "Graphic Design Services India",
    description: "Professional graphic design services in India. Brand identity, marketing materials, social media graphics, and UI/UX design. Govindani Infotech - creative design agency.",
    keywords: "graphic design services India, branding agency, visual identity, marketing materials, design company Pune",
  },
  logoDesigning: {
    title: "Logo Design Services India | Brand Identity",
    description: "Professional logo design services in India. Custom logos, brand identity packages, and visual branding for startups and businesses. Govindani Infotech - creative logo design agency.",
    keywords: "logo design India, professional logo, brand identity, logo design company, custom logo design Pune",
  },
  productShoot: {
    title: "Product Photography India | E-Commerce Shoots",
    description: "Professional product photography services in India. E-commerce product shoots, Amazon/Flipkart listing photos, and catalog photography. Govindani Infotech - expert product photographers.",
    keywords: "product photography India, e-commerce product shoot, Amazon product photography, catalog photography, product images",
  },
  aiProductShoot: {
    title: "AI Product Photography India | Product Shoots",
    description: "Revolutionary AI product photography services in India. Generate stunning product images with AI, reduce photoshoot costs by 80%. Govindani Infotech - AI product photography specialists.",
    keywords: "AI product photography, AI product shoot, AI-generated product images, product photography AI, AI photography India",
  },
  checkoutSystem: {
    title: "Checkout System Development India",
    description: "Custom checkout system development in India. Streamlined payment flows, multiple payment gateways, and conversion-optimized checkout. Govindani Infotech - e-commerce checkout experts.",
    keywords: "checkout system development, e-commerce checkout, payment gateway integration, checkout optimization, India",
  },
  platformListing: {
    title: "Marketplace Listings India | Amazon Seller",
    description: "Professional marketplace listing services in India. Amazon, Flipkart, Meesho, and other platform product listing optimization. Govindani Infotech - marketplace listing experts.",
    keywords: "marketplace listing India, Amazon seller services, Flipkart listing, product listing optimization, e-commerce marketplace",
  },
  linkedinAds: {
    title: "LinkedIn Ads Management India | B2B Ads",
    description: "Professional LinkedIn Ads management services in India. B2B lead generation, sponsored content, and InMail campaigns. Govindani Infotech - LinkedIn advertising experts.",
    keywords: "LinkedIn Ads management, B2B advertising, LinkedIn marketing India, B2B lead generation, LinkedIn ads agency",
  },
  paymentGateway: {
    title: "Payment Gateway Integration India | Razorpay",
    description: "Payment gateway integration services in India. Razorpay, PayU, CCAvenue, and Stripe setup for websites and apps. Govindani Infotech - payment gateway experts.",
    keywords: "payment gateway integration India, Razorpay setup, PayU integration, CCAvenue, payment gateway developer",
  },
  logisticIntegration: {
    title: "Logistics Integration India | Shipping API",
    description: "Logistics integration services in India. Shiprocket, Delhivery, and courier API integration for e-commerce. Govindani Infotech - logistics technology partner.",
    keywords: "logistics integration India, shipping API, Shiprocket integration, delivery partner API, e-commerce logistics",
  },
  marketplaceBrandListing: {
    title: "Brand Listing Services India",
    description: "Brand listing services in India. End-to-end seller onboarding on Amazon, Flipkart, Meesho, and other marketplaces. Govindani Infotech - marketplace listing specialists.",
    keywords: "brand listing India, Amazon seller onboarding, Flipkart seller, marketplace listing service, e-commerce seller",
  },
  leadGeneration: {
    title: "Lead Generation Services India | B2B Leads",
    description: "Professional lead generation services in India. B2B and B2C leads through Google Ads, social media, and content marketing. Govindani Infotech - lead generation experts.",
    keywords: "lead generation services India, B2B leads, B2C leads, lead generation agency, quality leads India",
  },

  // Social Media Pages
  socialMediaOverview: {
    title: "Social Media Marketing Services India | SMM",
    description: "Comprehensive social media marketing services in India. Instagram, Facebook, LinkedIn, and YouTube marketing for NGOs, businesses, and brands. Govindani Infotech - social media experts.",
    keywords: "social media marketing India, Instagram marketing, Facebook marketing, social media agency, digital marketing Pune",
  },
  socialMediaNGO: {
    title: "Social Media Marketing for NGOs India | SMM",
    description: "Specialized social media marketing for NGOs in India. Build donor engagement, share impact stories, and grow your nonprofit's online presence. Govindani Infotech - NGO digital marketing experts.",
    keywords: "social media for NGOs, nonprofit marketing, NGO digital marketing, donor engagement, NGO social media India",
  },
  socialMediaEcommerce: {
    title: "Social Media Marketing for E-Commerce India",
    description: "Social media marketing for e-commerce businesses in India. Product promotion, retargeting, and conversion campaigns. Govindani Infotech - e-commerce social media experts.",
    keywords: "e-commerce social media marketing, online store promotion, product advertising, e-commerce marketing India",
  },
  socialMediaRealEstate: {
    title: "Social Media Marketing for Real Estate India",
    description: "Social media marketing for real estate businesses in India. Property promotion, lead generation, and brand building. Govindani Infotech - real estate digital marketing experts.",
    keywords: "real estate social media marketing, property marketing India, real estate digital marketing, property advertising",
  },
  socialMediaHealthcare: {
    title: "Social Media Marketing for Healthcare India",
    description: "Social media marketing for healthcare providers in India. Hospital promotion, patient engagement, and medical practice marketing. Govindani Infotech - healthcare digital marketing experts.",
    keywords: "healthcare social media marketing, hospital marketing India, medical practice marketing, healthcare digital marketing",
  },
  socialMediaPersonalBranding: {
    title: "Personal Branding India | Social Media Presence",
    description: "Personal branding services on social media in India. Build your professional brand on Instagram, LinkedIn, and YouTube. Govindani Infotech - personal branding experts.",
    keywords: "personal branding social media, personal brand India, Instagram personal branding, LinkedIn personal brand, influencer marketing",
  },

  // WhatsApp Pages
  whatsappBusinessAPI: {
    title: "WhatsApp Business API Setup India | Partner",
    description: "WhatsApp Business API setup and integration in India. Official WhatsApp partner for business messaging, automation, and customer engagement. Govindani Infotech - WhatsApp API experts.",
    keywords: "WhatsApp Business API setup, WhatsApp API India, WhatsApp business messaging, WhatsApp API integration, official WhatsApp partner",
  },
  whatsappChatbot: {
    title: "WhatsApp Chatbot Development India",
    description: "WhatsApp chatbot development in India. AI-powered customer support, lead generation, and automation chatbots. Govindani Infotech - WhatsApp chatbot developers.",
    keywords: "WhatsApp chatbot development, WhatsApp chatbot India, AI chatbot, customer support automation, WhatsApp bot",
  },
  whatsappMarketing: {
    title: "WhatsApp Marketing India",
    description: "WhatsApp marketing services in India. Bulk messaging, broadcast lists, and campaign management for businesses. Govindani Infotech - WhatsApp marketing experts.",
    keywords: "WhatsApp marketing India, WhatsApp bulk messaging, WhatsApp campaign, WhatsApp broadcast, WhatsApp promotion",
  },
  whatsappAutomation: {
    title: "WhatsApp Automation India | Automated Messaging",
    description: "WhatsApp automation services in India. Automated replies, workflow automation, and chatbot integration. Govindani Infotech - WhatsApp automation experts.",
    keywords: "WhatsApp automation India, automated WhatsApp messages, WhatsApp workflow, WhatsApp auto-reply, WhatsApp integration",
  },
  whatsappForms: {
    title: "WhatsApp Forms India",
    description: "WhatsApp forms and lead collection in India. Interactive forms, surveys, and data collection through WhatsApp. Govindani Infotech - WhatsApp forms experts.",
    keywords: "WhatsApp forms India, WhatsApp lead collection, WhatsApp survey, interactive WhatsApp forms, WhatsApp data collection",
  },
  whatsappClickToAds: {
    title: "Click to WhatsApp Ads India",
    description: "Click to WhatsApp ads in India. Drive traffic and leads through WhatsApp advertising campaigns. Govindani Infotech - WhatsApp ads specialists.",
    keywords: "click to WhatsApp ads, WhatsApp advertising India, WhatsApp ads campaign, CTWA, WhatsApp lead generation",
  },
  whatsappCommerce: {
    title: "WhatsApp Commerce India",
    description: "WhatsApp commerce setup in India. Create your WhatsApp store, product catalog, and enable in-chat payments. Govindani Infotech - WhatsApp commerce experts.",
    keywords: "WhatsApp commerce India, WhatsApp store, WhatsApp catalog, WhatsApp shopping, in-chat payments",
  },
  whatsappCRM: {
    title: "WhatsApp CRM Integration India",
    description: "WhatsApp CRM integration in India. Connect WhatsApp with your CRM for seamless customer management. Govindani Infotech - WhatsApp CRM experts.",
    keywords: "WhatsApp CRM integration, WhatsApp customer management, CRM with WhatsApp, WhatsApp lead management, India",
  },
  whatsappWidget: {
    title: "WhatsApp Chat Widget India",
    description: "WhatsApp chat widget for websites in India. Add WhatsApp button to your website for instant customer support. Govindani Infotech - WhatsApp widget developers.",
    keywords: "WhatsApp chat widget, WhatsApp website button, WhatsApp integration, website WhatsApp chat, India",
  },
  whatsappNotification: {
    title: "WhatsApp Notification Library India",
    description: "WhatsApp notification library in India. Transactional messages, alerts, and notifications through WhatsApp. Govindani Infotech - WhatsApp notification experts.",
    keywords: "WhatsApp notifications India, transactional WhatsApp messages, WhatsApp alerts, notification library, WhatsApp API notifications",
  },
  whatsappVoiceCalling: {
    title: "WhatsApp Voice Calling India",
    description: "WhatsApp voice calling solutions for businesses in India. Voice calls, IVR, and communication tools. Govindani Infotech - WhatsApp voice solutions.",
    keywords: "WhatsApp voice calling, WhatsApp business calls, voice communication WhatsApp, WhatsApp IVR, India",
  },
  whatsappRcs: {
    title: "RCS Messaging India | Business Messaging",
    description: "RCS messaging services in India. Rich media messages, branded messages, and interactive content. Govindani Infotech - RCS messaging experts.",
    keywords: "RCS messaging India, Rich Communication Services, RCS business messaging, branded messages, India",
  },
  instagramAutomation: {
    title: "Instagram Automation India | Auto-Reply & DMs",
    description: "Instagram automation services in India. Auto-reply, DM automation, and comment management. Govindani Infotech - Instagram automation experts.",
    keywords: "Instagram automation India, Instagram auto-reply, Instagram DM automation, Instagram chatbot, Instagram marketing tools",
  },

  // Portfolio Pages
  ngoPage: {
    title: "NGO Website Development India | Donation",
    description: "Custom NGO websites and donation platforms for Indian nonprofits. 550 NGO websites built, ₹1100+ crore processed, 80G and FCRA compliance built in.",
    keywords: "NGO website development, donation platform India, NGO digital solutions, 80G donation website, FCRA compliance",
  },
  ngoPortfolio: {
    title: "NGO Website Portfolio | Non-Profit Projects",
    description: "Explore our portfolio of NGO websites and donation platforms — 550 of them. See how we've helped non-profits raise crores and manage donors effectively.",
    keywords: "NGO website portfolio, nonprofit projects, donation platform examples, NGO website samples, India",
  },
  ecommercePage: {
    title: "E-Commerce Development India | Online Stores",
    description: "Custom e-commerce development in India. Online stores, shopping carts, payment integration, and marketplace listing. Govindani Infotech - e-commerce development experts.",
    keywords: "e-commerce development India, online store development, shopping cart, e-commerce website, India",
  },
  virtualTour: {
    title: "Virtual Tour Technology India | 360° Tours",
    description: "360° virtual tour technology in India. Virtual tours for real estate, hospitality, and tourism. Govindani Infotech - virtual tour specialists.",
    keywords: "virtual tour India, 360 virtual tour, real estate virtual tour, virtual tour technology, India",
  },

  // Pricing Pages
  websitePricing: {
    title: "Website Development Pricing India | Packages",
    description: "Website development pricing in India. Affordable web design packages starting from ₹15,000. Custom websites, e-commerce, and CMS solutions. Govindani Infotech - transparent pricing.",
    keywords: "website development pricing, web design packages India, affordable website cost, website price India, web development cost",
  },
  socialMediaPricing: {
    title: "Social Media Marketing Pricing India | SMM",
    description: "Social media marketing pricing in India. Affordable SMM packages for Instagram, Facebook, and LinkedIn. Govindani Infotech - transparent social media pricing.",
    keywords: "social media marketing pricing, SMM packages India, social media cost, Instagram marketing price, Facebook ads cost",
  },
  otherServicesPricing: {
    title: "Digital Services Pricing India | Web Costs",
    description: "Digital services pricing in India. Web development, SEO, Google Ads, and other services pricing. Govindani Infotech - transparent digital services pricing.",
    keywords: "digital services pricing India, web development cost, SEO pricing, Google Ads cost, digital marketing pricing",
  },

  // Contact
  contactUs: {
    title: "Contact Us | Free Consultation",
    description: "Contact Govindani Infotech for NGO website development, WhatsApp API, digital marketing, and web development services. Free consultation available. Call +91-9201958271.",
    keywords: "contact Govindani Infotech, free consultation, digital agency Pune, NGO website inquiry, WhatsApp API inquiry",
  },

  // Careers
  careers: {
    title: "Careers | Join India's Digital Agency",
    description: "Join Govindani Infotech - India's leading digital solutions company. Explore career opportunities in web development, digital marketing, and more.",
    keywords: "careers Govindani Infotech, jobs Pune, digital agency careers, web developer jobs, marketing jobs India",
  },

  // Case Studies
  caseStudies: {
    title: "Case Studies | NGO Fundraising Success Stories",
    description: "Explore our case studies showing how Govindani Infotech helped NGOs raise crores through digital platforms. Real results, real impact.",
    keywords: "NGO case studies, digital transformation cases, NGO success stories, donation platform case study, India",
  },
};

export function getPageSEO(page: keyof typeof pageSEO) {
  return pageSEO[page] || pageSEO.home;
}
